import React from 'react';

import "../../../components/Table/Table.css";

const AttendanceSummaryFullRow = ({ summary }) => {
  return (
    <div className="app-data-table" style={{ overflow: "auto" }}>
      <table className="table table-bordered table-hover table-striped mb-0 attendance-summary-table">
        <thead>
          <tr>
            <th className="text-center align-middle py-3" style={{ minWidth: '100px' }}>Gender</th>
            <th className="text-center align-middle py-3" style={{ minWidth: '120px' }}>Students</th>
            <th className="text-center align-middle py-3" style={{ minWidth: '100px' }}>Present</th>
            <th className="text-center align-middle py-3" style={{ minWidth: '100px' }}>Absent</th>
            <th className="text-center align-middle py-3" style={{ minWidth: '100px' }}>On Leave</th>
          </tr>
        </thead>
        <tbody>
          {['male', 'female'].map((gender) => (
            <tr key={gender}>
              <td className="text-center align-middle py-2 font-weight-bold text-capitalize">
                {gender.toUpperCase()}
              </td>
              <td className="text-center align-middle py-2">
                {summary[gender]?.total || 0}
              </td>
              <td className="text-center align-middle py-2">
                <span className="attendance-badge present">{summary[gender]?.present || 0}</span>
              </td>
              <td className="text-center align-middle py-2">
                <span className="attendance-badge absent">{summary[gender]?.absent || 0}</span>
              </td>
              <td className="text-center align-middle py-2">
                <span className="attendance-badge on-leave">{summary[gender]?.on_leave || 0}</span>
              </td>
            </tr>
          ))}
          <tr key="3">
            <th className="text-center align-middle py-2 font-weight-bold text-capitalize">
              SUMMARY
            </th>
            <th className="text-center align-middle py-2">
              {summary['summary']?.total || 0}
            </th>
            <th className="text-center align-middle py-2">
              <span className="attendance-badge present">{summary['summary']?.present || 0}</span>
            </th>
            <th className="text-center align-middle py-2">
              <span className="attendance-badge absent">{summary['summary']?.absent || 0}</span>
            </th>
            <th className="text-center align-middle py-2">
              <span className="attendance-badge on-leave">{summary['summary']?.on_leave || 0}</span>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceSummaryFullRow;
